import React, { useEffect, useState, useContext, useCallback } from "react";
import "./Outlet.css";
import AdminHeader from "../../../Component/AdminHeader/AdminHeader";
import { FaRegClock } from "react-icons/fa";
import { AuthContext } from "../../../ContextAPI/VendorAuthContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_BASE = "https://fliplyn-b-c.fly.dev";

const Outlets = () => {
  const { vendor } = useContext(AuthContext);
  const vendorId = vendor?.vendorId;

  const navigate = useNavigate();

  const [stalls, setStalls] = useState([]);
  const [loading, setLoading] = useState(true);

  // ==========================
  // Fetch Stalls using Vendor ID
  // ==========================
  const fetchStalls = useCallback(async () => {
    if (!vendorId) return;

    try {
      console.log("Fetching stalls for vendor:", vendorId);

      const res = await axios.get(
        `${API_BASE}/stalls/owner/${vendorId}`
      );

      console.log("Stalls Response:", res.data);

      setStalls(res.data);
    } catch (error) {
      console.error("Error fetching stalls:", error);
    } finally {
      setLoading(false);
    }
  }, [vendorId]);

  // ==========================
  // useEffect
  // ==========================
  useEffect(() => {
    fetchStalls();
  }, [fetchStalls]);

  // ==========================
  // Navigate to Vendor Items
  // ==========================
  const handleOpenOutlet = (stallId) => {
    console.log("Opening stall:", stallId);

    navigate("/vendor-items", {
      state: { stallId }
    });
  };

  // ==========================
  // Format Time
  // ==========================
  const formatTime = (timeString) => {
    if (!timeString) return "N/A";

    const [hour, minute] = timeString.split(":");

    const date = new Date();
    date.setHours(hour);
    date.setMinutes(minute);

    return date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    });
  };

  return (
    <>
      <AdminHeader />

      <div className="outlets-page">
        <h1 className="title">My Outlets</h1>

        <p className="subtitle">
          Select an outlet to manage items and update availability.
        </p>

        {loading ? (
          <p style={{ marginTop: "20px" }}>Loading outlets...</p>
        ) : stalls.length === 0 ? (
          <p style={{ marginTop: "20px" }}>No outlets assigned.</p>
        ) : (
          <div className="outlet-grid">
            {stalls.map((stall) => (
              <div className="outlet-card" key={stall.id}>
                <img
                  src={stall.image_url || "/placeholder.png"}
                  alt={stall.name}
                  className="outlet-img"
                />

                <div className="outlet-info">
                  <h2 className="outlet-name">{stall.name}</h2>

                  <p className="outlet-desc">
                    {stall.description || "No description available"}
                  </p>

                  <div className="timings">
                    <span className="open-time">
                      <FaRegClock className="clock-icon open" />
                      Opens at {formatTime(stall.opening_time)}
                    </span>

                    <span className="close-time">
                      <FaRegClock className="clock-icon close" />
                      Closes at {formatTime(stall.closing_time)}
                    </span>
                  </div>
                </div>

                <button
                  className="open-btn"
                  onClick={() => handleOpenOutlet(stall.id)}
                >
                  Open
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Outlets;